<template>
	<div id="ColumnComponent" class="column-component">
		<button @click="getStoreRackSideRowColumnLocal" ref="btnShowStoreRackSideRowColumn" v-show="false">Buscar Columna</button>
		<div v-if="searchingStoreRackSideRowColumn">
			Buscando Modulo ...
		</div>
		<div v-else>
			<div v-if="objectStoreRackSideRowColumn.id == 0">

			</div>
			<div v-else>
				<div class="text-center">
					<table class="border border-dark text-left" style="margin: 0 auto; width:300px">
						<tr>
							<td rowspan="2" class="p-1 border border-dark" :style="'background-color:' + objectStoreRackSideRowColumn.store_rack_side.color +'; text-shadow: 0.1em 0.1em 0.05em #fff'" >
								<svg width="20" height="60">
									<text x="10" y="0" writing-mode="tb" glyph-orientation-vertical="0">{{objectStoreRackSideRowColumn.store_rack.name.toUpperCase()}}</text>
								</svg>
								<small>
									<svg width="15" height="60">
										<text x="10" y="0" writing-mode="tb" glyph-orientation-vertical="0">{{objectStoreRackSideRowColumn.store.name}}</text>
									</svg>
								</small>
							</td>
							<td class="text-center">{{objectStoreRackSideRowColumn.store_rack_side.name}} {{objectStoreRackSideRowColumn.name}}-{{objectStoreRackSideRowColumn.store_rack_side_row.name}}</td>
						</tr>
						<tr>
							<td class="text-center">{{objectStoreRackSideRowColumn.code}}</td>
						</tr>
					</table>
				</div>
				<div class="row justify-content-center mt-3" v-if="objectStoreRackSideRowColumn.products.length > 0">
					<div class="col-6 col-sm-4 col-md-2" v-for="(item, index) in objectStoreRackSideRowColumn.products" :key="index">
						<div class="card" :class="(productStoreRackSideRowColumnId == item.pivot.id) ? 'border border-secondary' : ' m-1'" @click="selectProductStoreRackSideRowColumnLocal(item.pivot.id)" :style="(item.pivot.quantity > 0) ? '' : 'opacity:0.5'">
							<div class="card-body product">
								<i class="far fa-trash-alt pointer text-danger" style="float: right; position: absolute; right: 20px; z-index: 1;" @click="deleteProductStoreRackSideRowColumnLocal(item)"></i>
								<div>Cod: {{item.id}}</div>
								<div class=""><small class="text-muted">{{item.isbn}}</small></div>
								<div>
									<img :src="(item.img == null || item.img == '') ? '/img/img-not-found.png' : item.img" style="width: 100%;">
								</div>
								<div style="width: 100%;  white-space: nowrap;  text-overflow: ellipsis;  overflow: hidden;">{{item.name}}</div>
								<div class="text-center"><h6 class="text-muted">{{methodFormatNumber(item.pivot.quantity)}} unidades</h6></div>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="text-center">
					No hay productos asignados a este Modulo
				</div>
				<div class="text-center pt-2" v-show="!savingProductStoreRackSideRowColumn && !searchingProduct">
					<input-search-intelligent-component
						:minCharsAnalyze="1"
						:analyzeAuto="false"
						:_placeholder="(productStoreRackSideRowColumnId == 0) ? 'Escanee el articulo' : 'Escanee el articulo o ingrese la cantidad'"
						_class="text-center"
						_style="width:100%"
						@actionKeyEnter="actionKeyEnterLocal"
						ref="inputSearchIntelligentComponentCode">
					</input-search-intelligent-component>
				</div>
				<div v-show="savingProductStoreRackSideRowColumn || searchingProduct" class="text-center">
					{{ messageAction }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import storeRackSideRowColumn from '@/mixins/stores/storeRackSideRowColumn.js'
	import product from '@/mixins/products'
	import productStoreRackSideRowColumn from '@/mixins/products/productStoreRackSideRowColumn.js'

	import InputSearchIntelligentComponent from '@/components/InputSearchIntelligentComponent.vue'

	export default {
		name: 'ColumnComponent',
		mixins: [axiosAction, errors, mixin, storeRackSideRowColumn, product, productStoreRackSideRowColumn],
		props: ['id'],
		data () {
			return {
				idLocal: 0,
				productStoreRackSideRowColumnId: 0,
				messageAction: ''
			}
		},
		components: {
			'input-search-intelligent-component': InputSearchIntelligentComponent,
		},
		computed: {
		},
		methods: {
			actionKeyEnterLocal(data) {
				switch (data.result) {
					case 'ISBN':
					case 'PRODUCT':
						this.showProductLocal(data.data)
						break;
					case 'INTEGER':
						this.updateProductStoreRackSideRowColumnLocal(data.data)
						break;
					case 'STORERACKSIDEROWCOLUMN':
						this.showStoreRackSideRowColumnLocal(parseInt(data.data))
						break;
					default:
						break;
				}
			},
			deleteProductStoreRackSideRowColumnLocal(item) {
				if(confirm('Está apunto de quitar "' + item.name + '" (' + item.id + ')\n¿Desea continuar?')) {
					this.messageAction = 'Borrando Articulo del modulo ...'
					this.deleteProductStoreRackSideRowColumn(item.pivot.id)
				}
			},
			deleteProductStoreRackSideRowColumnResultLocal(response) {
				if(response.data.success == true) {
					this.productStoreRackSideRowColumnId = 0
					let index = this.objectStoreRackSideRowColumn.products.map((el) => parseInt(el.pivot.id)).indexOf(parseInt(response.data.data))
					if(index > -1) {
						let products = this.objectStoreRackSideRowColumn.products.splice(index,1)
					}
				}
			},
			getStoreRackSideRowColumnLocal() {
				if(this.id > 0) {
					this.showStoreRackSideRowColumnLocal(this.id)
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'deleteProductStoreRackSideRowColumnResult': this.deleteProductStoreRackSideRowColumnResult(response); break;			
					case 'saveProductStoreRackSideRowColumnResult': this.saveProductStoreRackSideRowColumnResult(response); break;			
					case 'showStoreRackSideRowColumnResult': this.showStoreRackSideRowColumnResult(response); break;			
					case 'showProductResult': this.showProductResult(response); break;
					case 'updateProductStoreRackSideRowColumnResult': this.updateProductStoreRackSideRowColumnResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			selectProductStoreRackSideRowColumnLocal(id) {
				this.productStoreRackSideRowColumnId = id
				setTimeout(() => { this.$refs.inputSearchIntelligentComponentCode.$refs.btnSetFocus.click()}, 100)
			},
			showProductLocal(id) {
				this.productStoreRackSideRowColumnId = 0
				let index = this.objectStoreRackSideRowColumn.products.map((el) => parseInt(el.id)).indexOf(parseInt(id))
				if(index == -1)
					index = this.objectStoreRackSideRowColumn.products.map((el) => parseInt(el.isbn)).indexOf(parseInt(id))

				if(index > -1) {
					this.selectProductStoreRackSideRowColumnLocal(this.objectStoreRackSideRowColumn.products[index].pivot.id)
				} else {
					this.messageAction = 'Buscando Articulo ...'
					this.showProduct(id)
				}
			},
			showProductResultLocal(response) {
				if(response.data.success == true) {
					this.messageAction = 'Asigando Articulo al Modulo ...'
					this.saveProductStoreRackSideRowColumn(response.data.data.id, this.idLocal)
				} else {
					this.$snotify.error('No se encontró nada', 'Error')
				}
			},
			saveProductStoreRackSideRowColumnResultLocal(response) {
				if(response.data.success == true) {
					this.objectStoreRackSideRowColumn.products.push(response.data.data)
					this.selectProductStoreRackSideRowColumnLocal(response.data.data.pivot.id)
				} else {
					this.$snotify.error('Algo no salió bien', 'Error')
				}
			},
			showStoreRackSideRowColumnLocal(id) {
				this.clearObjectStoreRackSideRowColumn()
				this.productStoreRackSideRowColumnId = 0
				if(id > 0) {
					this.idLocal = id
					this.showStoreRackSideRowColumn(this.idLocal)
				}
			},
			showStoreRackSideRowColumnResultLocal(response) {
				setTimeout(() => { this.$refs.inputSearchIntelligentComponentCode.$refs.btnSetFocus.click()}, 100)
			},
			updateProductStoreRackSideRowColumnLocal(q) {
				if(this.isInt(q) && this.productStoreRackSideRowColumnId > 0) {
					this.messageAction = 'Actualizando cantidad ...'
					this.clearObjectProductStoreRackSideRowColumn()
					this.objectProductStoreRackSideRowColumn.id = this.productStoreRackSideRowColumnId
					this.objectProductStoreRackSideRowColumn.quantity = q
					this.updateProductStoreRackSideRowColumn()
				} else {
					this.$snotify.warning('Tiene que seleccionar el producto antes de ingresar la cantidad', 'Atención')
				}
			},
			updateProductStoreRackSideRowColumnResultLocal(response) {
				if(response.data.success == true) {
					if(response.data.message == 'ACTUALIZADO') {
						let index = this.objectStoreRackSideRowColumn.products.map((el) => parseInt(el.pivot.id)).indexOf(parseInt(response.data.data.id))
						if(index > -1) {
							this.objectStoreRackSideRowColumn.products[index].pivot.quantity = response.data.data.quantity
							this.objectStoreRackSideRowColumn.products[index].pivot.status_id = response.data.data.status_id
						}
					}
				}
				setTimeout(() => { this.$refs.inputSearchIntelligentComponentCode.$refs.btnSetFocus.click()}, 100)
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.product {
		.fa-trash-alt {
			visibility: hidden;
		}
	}
	.product:hover {
		.fa-trash-alt {
			visibility: visible;
		}
	}
</style>
